import { BriefDisplayStatus } from '@fiverr-private/dynamic_matching';
import { isCurrentUser } from '../../../../../lib/utils/getters';
import { BriefAction } from '../../../../../lib/types/brief';

export const calculateAction = (status: BriefDisplayStatus, ownerId: string): BriefAction => {
    const isUserOwner = isCurrentUser(ownerId);

    if (!isUserOwner) {
        return BriefAction.VIEW_BRIEF;
    }

    switch (status) {
        case BriefDisplayStatus.REJECTED: {
            return BriefAction.VIEW_BRIEF;
        }

        case BriefDisplayStatus.NO_INVITES_SENT: {
            return BriefAction.INVITE_FREELANCERS;
        }

        default:
            return BriefAction.MANAGE_BRIEF;
    }
};
